export const NOTE_NAMES = [
    "C",
    "C#",
    "D",
    "D#",
    "E",
    "F",
    "F#",
    "G",
    "G#",
    "A",
    "A#",
    "B",
];

export const KEYBOARD_MAP = {
    a: 60, // Middle C
    w: 61,
    s: 62,
    e: 63,
    d: 64,
    f: 65,
    t: 66,
    g: 67,
    y: 68,
    h: 69,
    u: 70,
    j: 71,
    k: 72,
    o: 73,
    l: 74,
    p: 75,
};

export const INSTRUMENTS = [
    { name: "Piano", url: "0000_FluidR3_GM_sf2_file.js", variable: "_tone_0000_FluidR3_GM_sf2_file" },
    { name: "Piano 2", url: "0000_Chaos_sf2_file.js", variable: "_tone_0000_Chaos_sf2_file" },
    { name: "Guitar", url: "0382_FluidR3_GM_sf2_file.js", variable: "_tone_0382_FluidR3_GM_sf2_file" },
    { name: "Saw", url: "0383_GeneralUserGS_sf2_file.js", variable: "_tone_0383_GeneralUserGS_sf2_file" },
    { name: "Sin", url: "0386_GeneralUserGS_sf2_file.js", variable: "_tone_0386_GeneralUserGS_sf2_file" },
    { name: "Violin", url: "0400_Aspirin_sf2_file.js", variable: "_tone_0400_Aspirin_sf2_file" },
    { name: "Viola", url: "0410_Aspirin_sf2_file.js", variable: "_tone_0410_Aspirin_sf2_file" },
    { name: "Cello", url: "0420_Aspirin_sf2_file.js", variable: "_tone_0420_Aspirin_sf2_file" },
    { name: "Harp", url: "0460_Aspirin_sf2_file.js", variable: "_tone_0460_Aspirin_sf2_file" },
    { name: "Clarinet", url: "0640_Aspirin_sf2_file.js", variable: "_tone_0640_Aspirin_sf2_file" },
    { name: "Flute", url: "0710_Aspirin_sf2_file.js", variable: "_tone_0710_Aspirin_sf2_file" },
    { name: "Saxophone", url: "0730_Aspirin_sf2_file.js", variable: "_tone_0730_Aspirin_sf2_file" },
];

// Add new constant for instrument page titles
export const INSTRUMENT_TITLES = {
    piano: "Piano",
    piano2: "Piano",
    guitar: "Guitar",
    saw: "Saw",
    sin: "Sin",
    violin: "Violin",
    viola: "Viola",
    cello: "Cello", 
    harp: "Harp",
    clarinet: "Clarinet",
    flute: "Flute",
    saxophone: "Saxophone"
};